// **initial state
const initialState = {
    paths: JSON.parse(localStorage.getItem('helpCenter')) ? JSON.parse(localStorage.getItem('helpCenter')) : [{display: {en: 'Help center', es: 'Centro de ayuda'}, path: '/helpCenter', id: ''}]
}

const helpCenter = (state = initialState, action) => {
    switch (action.type) {
        case 'HANDLE_PATHS':
            return { ...state, paths: [...action.value] }
        default:
            return state
    }

}

export default helpCenter